// Vendor libraries
import { BrowserModule } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
// Modules
import { ConfigModule } from 'NewAngular/config/config.module';
import { IconModule } from 'NewAngular/features/directives/icon/icon.module';
import * as i0 from "@angular/core";
export class RiskInfoCheckboxesModule {
}
RiskInfoCheckboxesModule.ɵfac = function RiskInfoCheckboxesModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || RiskInfoCheckboxesModule)(); };
RiskInfoCheckboxesModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: RiskInfoCheckboxesModule });
RiskInfoCheckboxesModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [BrowserModule, CommonModule, ConfigModule, FormsModule, IconModule] });
